import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

/**
 * @deprecated [fabric-deprecated] - use fabric micro-frontends/app-account/types/config/config.model.ts
 */
@Injectable({
	providedIn: "root",
})
export class PhoneVerificationConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getEndpoint(): string {
		return this.configService.get(
			(x) => x.common.phoneVerification.endpoints!.phoneVerification,
			"v1/phonenumber-verification-codes"
		);
	}
}
